<template>
  <div class="siteMain" ref="container">
    <SearchForm v-model="keyWord" placeholder="请输入站点名称"></SearchForm>
    <AddOperate @click="add"></AddOperate>
    <isEmpty v-if="plotList.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          您还没有添加充电站
        </div>
        <div class="is-empty_descript">
          <p>请点击下方 ’添加充电站‘ 按钮</p>
          <p>开始您的运营之旅吧！</p>
        </div>
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">全部站点<span>{{ total }}</span></div>
      <mu-load-more @refresh="refresh" :refreshing="refreshing" :loaded-all="loaded_all" :loading="loading" @load="load">
        <div class="list-box">
          <div class="list-item" v-for="(item, index) in plotList" :key="`list-item_${index}`">
            <div  @click="edit(item)" style="display: flex">
              <el-image class="cover" fit="cover" :src="item.fileUrl"></el-image>
              <div class="item-info">
                <div class="title text-overflow">{{ item.plotName || '未知' }}</div>
                <div class="tags">
                  <div class="tag-item" :key="`tag-item_${tagIndex}`"
                    v-for="(tag, tagIndex) in computedList(item.supportingFacilities, typeList)">{{ tag }}
                  </div>
                </div>
                <div class="address text-overflow">位置：{{ item.address || '未知地址' }}</div>
              </div>
            </div>

            <div class="more">
              <el-popover popper-class="site-custom" trigger="click"  placement="bottom-start">
                <div  class="tips-box">
                  <!--                  <div @click="edit(item)">编辑</div>-->
                  <div @click.stop="fencheng(item)">分成设置</div>
                  <div @click.stop="zhanwei(item)">占桩费设置</div>
                  <div @click.stop="delPlot(item)">删除</div>
                </div>
                <img class="icon"  slot="reference" src="@/assets/image/icon/more.png" alt="" />
              </el-popover>

            </div>
          </div>
        </div>
      </mu-load-more>
    </div>





    <van-dialog @close="fenchengVisible=false" v-model="fenchengVisible" :show-cancel-button="false"
      :show-confirm-button="false" width="8.8918rem" class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title">分成设置</div>

        <div class="dialog-item">
          <div class="item-title">站点名称</div>
          <div class="item-value">{{sharingTypeForm.plotName}}</div>
        </div>

        <div class="dialog-item">
          <div class="item-title">代理商名称</div>
          <div class="item-value">{{sharingTypeForm.operatorName}}</div>
        </div>

        <div class="dialog-item">
          <div class="item-title">分成方式</div>
          <div>
             <el-select v-model="sharingTypeForm.sharingTypeLabel" 
             placeholder="请选择分成方式" 
             @focus="selectClick()">
             </el-select>
          </div>
        </div>

         <div class="dialog-item">
          <div class="item-title">代理商分成比例(%)</div>
          <div>
<!--             <el-input type="number" v-model="sharingTypeForm.operatorPercent" style="width: 150px" :min="0"
              :max="100" @input="validateOperatorPercent" @change="changeOperatorPercent"
            placeholder="请输入代理商分成比例" clearable />
 -->
             <el-input-number ref="priceInput" 
             v-model="sharingTypeForm.operatorPercent" 
             :controls="false" 
             @input="validateOperatorPercent" @change="changeOperatorPercent"
             :precision="2" :min="0.0" :max="100" :step="0.01"
              style="width: 150px;" placeholder="请输入代理商分成比例"></el-input-number>

          </div>
        </div>

         <div class="dialog-item">
          <div class="item-title">平台分成比例(%)</div>
          <div>
            <el-input maxlength="15" type="number" 
            v-model="sharingTypeForm.platformPercent" style="width: 150px"
            placeholder="请输入代理商分成比例" clearable readonly/>
          </div>
        </div>

        <div class="content-box">
          <div class="confirm" @click="fengchengConfirm()">确认</div>
          <div class="text" @click="fenchengVisible=false">我再想想</div>
        </div>
      </div>
    </van-dialog>


    <van-dialog @close="occupancyDialogVisible=false" v-model="occupancyDialogVisible" :show-cancel-button="false"
      :show-confirm-button="false" width="8.8918rem" class="va-dialog">
        <template v-slot:title></template>

        <div class="dialog-content">
          <div class="title">占桩费设置</div>

            <el-form
                ref="form_occupancy_set"
                :model="occupancyForm"
                label-width="180px"
                :rules="occupancyFormRule"
            >
              <el-form-item label-width="150px" class="nav-form-item" label="站点名称" prop="plotName">
                <el-input
                    maxlength="10"
                    max="120"
                    v-model="occupancyForm.plotName"
                    style="width: 150px"
                    disabled
                />
              </el-form-item>
              <el-form-item label-width="150px" class="nav-form-item" label="免费占用时长(分钟)" prop="freeTime">
                <el-input
                    maxlength="10"
                    max="100"
                    v-model="occupancyForm.freeTime"
                    style="width: 150px"
                    placeholder="请输入免费占用时长"
                />
              </el-form-item>
              <el-form-item label-width="150px" class="nav-form-item" label="收费单价(元/分钟)" prop="occupancyPrice">
                <el-input
                    v-model="occupancyForm.occupancyPrice"
                    style="width: 150px"
                    placeholder="请输入收费单价"
                />
              </el-form-item>
              <el-form-item label-width="150px" class="nav-form-item" label="封顶金额(元)" prop="occupancyMaxPrice">
                <el-input
                    v-model="occupancyForm.occupancyMaxPrice"
                    style="width: 150px"
                    placeholder="请输入封顶金额"
                />
              </el-form-item>
            </el-form> 

          <div class="content-box">
            <div class="confirm" @click="occupancyConfirm()">确认</div>
            <div class="text" @click="occupancyDialogVisible=false">我再想想</div>
          </div>

        </div>

    </van-dialog>


    <nut-picker
        :is-visible="showSharingType"
        :list-data="sharingTypeOptions"
        @close="showSharingType=false"
        @confirm="confirmSharingType"
    ></nut-picker>  


  </div>
</template>
<script>
import { getPlotList, deletePlot, setSharingType, addOccupancySettings } from "@/api/newApi";
import { Toast } from "vant";
import "vant/lib/toast/style/index";
import AddOperate from "@/components/add-operate/index.vue";
import Decimal from 'decimal.js';

export default {
  data () {
    return {
      plotList: [],
      typeList: ["免费WIFI", "便利店", "洗车", "厕所", "热水", "休息室"],
      token: "",
      refreshing: false,
      loaded_all: false,
      loading: false,
      pages: 0,
      num: 1,
      keyWord: "",
      total: 0,
      fenchengVisible:false,
      sharingTypeForm: {
        id: '',
        plotName: '',
        operatorName: '',
        sharingType: null,
        operatorPercent: null,
        platformPercent: null,
        sharingTypeLabel:'',
      },
      showSharingType:false,
      sharingTypeOptions: [[
        { label: 1, value: '电费' },
        { label: 2, value: '服务费' },
        { label: 3, value: '电费+服务费'}
      ]],
      occupancyDialogVisible:false,
      occupancyForm: {
        plotId: '',
        freeTime: '',
        occupancyPrice: '',
        maxTime: '',
        occupancyMaxPrice: '',
      },
      occupancyFormRule: {
        freeTime: [{required: true, message: "请输入免费时长", trigger: "blur"}],
        occupancyPrice: [{required: true, message: "请输入占位费", trigger: "blur"}],
        occupancyMaxPrice: [{required: true, message: "请输入封顶金额", trigger: "blur"}],
      },


    };
  },
  components: {
    AddOperate
  },
  mounted () {
    this.getList({ pageNo: this.num, pageSize: 5, keyWord: this.keyWord });
  },
  watch: {
    keyWord: function () {
      this.plotList = [];
      this.num = 1;
      this.getList({ pageNo: this.num, pageSize: 5, keyWord: this.keyWord });
    },
  },
  computed: {
    computedList () {
      return (data, typeList) => {
        if (data == "" || !data) {
          return [];
        } else {
          let list = data.split(",").map((item) => {
            return typeList[Number(item) - 1];
          });
          return list;
        }
      };
    },
  },
  methods: {
    getList (params) {
      getPlotList(params)
        .then((res) => {
          if (res.data != "") {
            if (res.message.code == 0) {
              this.total = res.data.total;
              this.pages = res.data.pages;
              res.data.records.forEach((item) => {
                this.plotList.push(item);
              });
              if (res.data.pages == this.num) {
                Toast("已加载全部数据");
                this.loaded_all = true;
              }
            }
          } else {
            this.plotList = [];
            Toast("暂无数据");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    load () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 1;
        if (this.num <= this.pages) {
          this.getList({
            pageNo: this.num,
            pageSize: 5,
            keyWord: this.keyWord,
          });
        }
      }, 2000);
    },

    refresh () {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      this.num = 1;
      this.plotList = [];
      setTimeout(() => {
        this.refreshing = false;
        this.getList({ pageNo: this.num, pageSize: 5, keyWord: this.keyWord });
      }, 1000);
    },

    add () {
      this.$router.push({
        path: "/admin/addSite",
      });
    },
    delPlot (item) {
      if (item.pileNum && item.pileNum > 0) {
        Toast("此站点下有运营的充电桩，不可删除");
      } else {
        deletePlot({ id: item.id }).then((res) => {
          if (res.message.status) {
            Toast("删除成功");
            this.num = 1;
            this.plotList = [];
            this.getList({
              pageNo: this.num,
              pageSize: 5,
              keyWord: this.keyWord,
            });
          }
        });
      }
    },
    edit (item) {
      this.$router.push({
        path: "/admin/addSite",
        query: item,
      });
    },
    fencheng(row){
      this.sharingTypeForm.id = null;
      this.sharingTypeForm.plotName = null;
      this.sharingTypeForm.operatorName = null;
      this.sharingTypeForm.sharingType = null;
      this.sharingTypeForm.operatorPercent =  null;
      this.sharingTypeForm.platformPercent =  null;
      this.sharingTypeForm.sharingTypeLabel =  '';

      this.sharingTypeForm.id = row.id;
      this.sharingTypeForm.plotName = row.plotName;
      this.sharingTypeForm.operatorName = row.operatorName;
      this.sharingTypeForm.sharingType = row.sharingType;
      this.sharingTypeForm.operatorPercent =  row.operatorPercent;
      this.sharingTypeForm.platformPercent =  row.platformPercent;
      this.sharingTypeForm.sharingTypeLabel = row.sharingType == 1 ? '电费' :  row.sharingType == 2 ? '服务费' : '电费+服务费';

      this.fenchengVisible = true;
    },
    zhanwei(row) {
      console.log('站点:', row)
      this.occupancyForm.plotId = row.id;
      this.occupancyForm.plotName = row.plotName
      this.occupancyForm.occupancyPrice = row.occupancyPrice
      this.occupancyForm.freeTime = row.occupancyFreeTime
      this.occupancyForm.occupancyMaxPrice = row.occupancyMaxPrice
      this.occupancyDialogVisible = true;
    },
    validateOperatorPercent(value) {
      if (value < 0) {
        value = 0;
      } else if (value > 100) {
        value = 100;
      }
      // 保留两位小数
      this.sharingTypeForm.operatorPercent = value;
    },
    changeOperatorPercent() {
      this.sharingTypeForm.platformPercent = new Decimal(100).minus(new Decimal(this.sharingTypeForm.operatorPercent));
    },
    confirmSharingType(even){
      this.sharingTypeForm.sharingTypeLabel = even[0].value;
      this.sharingTypeForm.sharingType = even[0].label;
      this.showSharingType = false;
    },
    fengchengConfirm(){
        setSharingType(this.sharingTypeForm).then((res) => {
          if (res.message.code==0) {
            Toast("分成方式设置成功！");
            this.fenchengVisible = false;

            this.num = 1;
            this.plotList = [];
            this.getList({ pageNo: this.num, pageSize: 5, keyWord: this.keyWord });

          }else {
             Toast(res.message.message);
          }

        }).catch(err => {
          this.fenchengVisible = false;
          Toast("分成方式设置失败");
      });

    },
    selectClick(){
       console.log("go selectClick");
       this.showSharingType = true;
    },
    occupancyConfirm(){
      this.$refs.form_occupancy_set.validate((valid) => {
        if (valid) {
          addOccupancySettings(this.occupancyForm).then((res) => {

            if (res.message.code==0) {
              Toast("占桩费设置成功");
              this.occupancyDialogVisible = false;
              this.num = 1;
              this.plotList = [];
              this.getList({ pageNo: this.num, pageSize: 5, keyWord: this.keyWord });
            }else {
               Toast(res.message.message);
            }
            
          }).catch((err) => {
            Toast("设置失败:" + err);
          })
        } else {
          Toast("请填写表单");
        }
      })

    }

  },
};
</script>
<style lang="scss">
@import "@/assets/sass/state.scss";
.site-custom{
     min-width: 120px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
}

.popper__arrow {
  border-bottom-color: white !important;

  &:after {
    border-bottom-color: white !important;
  }
}

.tips-box {
  font-size: $fontSize_12;
  color: #888888;

  div {
    padding: 0.3rem 1rem;
    border-bottom: 1px solid #f7f7f7;
  }

  div:first-child {
    padding-top: 0.1rem;
  }

  div:last-child {
    padding-bottom: 0.1rem;
    border-bottom: 0px solid #f7f7f7;
  }

}

</style>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.siteMain {
  //padding: 0.2667rem 0.4rem 1.76rem;
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;

  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      color: #666666;
      font-size: $fontSize_14;

      span {
        color: #3D3D3D;
        margin-left: 0.1rem;
        font-weight: bold;
      }
    }

    .list-item {
      display: flex;
      background-color: white;
      margin-bottom: 0.3rem;
      padding: 0.3rem;
      border-radius: 0.1621rem;
      position: relative;

      .more {
        position: absolute;
        top: 0.3rem;
        right: 0.3rem;

        .icon {
          width: 0.4783rem;
          height: 0.4810rem;
        }
      }

      .cover {
        width: 2.0378rem;
        height: 2.0378rem;
        flex-shrink: 0;
        align-self: center;

      }

      .item-info {
        padding-left: 0.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        max-width: 70%;


        .title {
          color: #3D3D3D;
          font-weight: bold;
          font-size: $fontSize_14;
          flex: 1;
        }

        .address {
          color: #888888;
          font-size: $fontSize_12;
          margin-top: 0.2rem;
        }

        .tags {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          margin-top: 0.1rem;

          .tag-item {
            font-size: $fontSize_10;
            color: #409EFF;
            padding: 0.1rem 0.2rem;
            background-color: #ECF5FF;
            border: 1px solid #D9ECFF;
            border-radius: 0.0540rem;
            flex-shrink: 0;
            margin-right: 0.2rem;
            margin-bottom: 0.2rem;
          }
        }
      }
    }
  }
}


  .dialog-content {
    padding: 0.3rem 0;

    .title {
      text-align: center;
      font-size: 0.3783rem;
      color: #3D3D3D;
      font-weight: bold;
      padding: 0.3rem;
    }

    .content-box {
      text-align: center;

      .desc {
        color: #666666;
        font-size: 0.3243rem;
      }

      .confirm {
        width: 5.5135rem;
        border-radius: 1rem;
        padding: 0.2rem;
        margin: 0 auto;
        background-color: #4664DF;
        color: white;
        font-size: 0.3243rem;
        margin-top: 0.6rem;
      }

      .text {
        padding: 0.3rem;
        margin-top: 0.3rem;
        font-size: 0.3243rem;
        color: #888888;
      }
    }
  }


.dialog-item{
    display: flex;
    margin: 0px 10px 15px 10px;
    text-align: center;
    align-items: center;

    .item-title{
      width: 120px;
    }

    .item-value{
      padding-left: 0.3rem !important;
    }
}

/* 覆盖 el-input-number 的默认样式 */
::v-deep(.el-input-number .el-input__inner) {
  text-align: left !important; /* 设置文字居左 */
}

</style>
